export const enViewKitchen = {
  navbarButton: "View public information",
  pickBusinessDaysButton: "Pick business days",
  pickBusinessDaysText:
    "Choose the days that you can or cannot work (customized kitchen schedules).",
  kitchenInfo: "The data shown above will be shared with your customers.",
  kitchenInfoNote: "Note, this is not related to your personal information.",
};
